import React from "react";
import { openAgent } from "../../utils/openAgent";

export const AiStrategyExpertSection = () => {

  return (
    <section className="relative w-full overflow-hidden bg-[#030914] py-16 sm:py-20 lg:py-24 text-white min-h-[460px] lg:min-h-[500px] flex items-center">
      {/* Background panoramic Earth graphic */}
      <img
        src="/images/ai-strategy-bg.png"
        alt="Earth network view with Higher Brighter Together"
        className="absolute inset-0 h-full w-full object-cover object-right md:object-center pointer-events-none select-none"
      />

      {/* Subtle left-side dark gradient to ensure optimal text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#030914]/95 via-[#030914]/60 to-transparent pointer-events-none lg:w-[65%]" />

      <div className="relative z-10 mx-auto max-w-[1440px] w-full px-6 lg:px-[70px]">
        <div className="flex flex-col gap-3.5 max-w-[680px]">
          {/* Pre-title / Eyebrow */}
          <p className="text-[11px] sm:text-[12px] font-semibold uppercase tracking-[3px] text-[#94A3B8]">
            LET'S TALK
          </p>

          {/* Main Headline with exact screenshot line breaks and colors */}
          <h2 className="text-[28px] sm:text-[38px] lg:text-[46px] xl:text-[50px] font-bold leading-[1.12] tracking-tight">
            <span className="text-white block sm:whitespace-nowrap">
              Enough about what AI can do.
            </span>
            <span className="text-[#A7C8FE] block sm:whitespace-nowrap">
              Let's discover what it can do
            </span>
            <span className="text-[#A7C8FE] block sm:whitespace-nowrap">
              for your business.
            </span>
          </h2>

          {/* Subtitle Paragraph with exact line breaks */}
          <p className="mt-2.5 text-[14px] sm:text-[15px] leading-[24px] text-[#C0D1E5] max-w-[650px]">
            <span className="block sm:whitespace-nowrap">
              Tell us about your company or website and we'll show you your personalized
            </span>
            <span className="block">
              AI opportunities.
            </span>
          </p>

          {/* Pill Outline Button */}
          <div className="pt-4 sm:pt-6">
            <button
              onClick={openAgent}
              className="inline-flex items-center justify-center rounded-full border border-white/70 bg-black/30 px-7 py-3 text-[14px] sm:text-[15px] font-medium text-white shadow-sm backdrop-blur-sm transition-all duration-300 hover:border-white hover:bg-white/10 hover:scale-[1.03] active:scale-95 cursor-pointer"
            >
              Talk to an AI Strategy Expert
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiStrategyExpertSection;
